import dictionary from "@/utils/dictionary";

export const DEFAULT_ITEMS = [
    {
        label: "Introduction",
        href: "/#section_introduction",
    },
    {
        label: "Projects",
        href: "/#section_projects",
    },
    {
        label: "Experiences",
        href: "/#section_experiences",
    },
    {
        label: "Testimonials",
        href: "/#section_testimonials",
    },
    {
        label: "Devlog",
        href: "/#section_devlog",
    },
    {
        label: dictionary.brief.navigation,
        href: "/daily-developer-brief",
    },
    {
        label: "About",
        href: "/#section_about",
    },
    {
        label: "Skills",
        href: "/#section_skills",
    },
];
